import { type ExclusionAreaProperties } from './exclusionAreaTypeResolution'

// Monitoreo saves an exclusion area with `name` = type label and the user's name in `otherName`,
// while Establecimientos writes the user's name into both. `otherName` is therefore the name the
// user recognizes whenever it exists.
export const getFeatureDisplayName = (properties?: ExclusionAreaProperties): string =>
  properties?.otherName || properties?.name || ''
